import { z } from 'zod'
import { NativeMessageSchema } from './NativeMessage'

export const PushNotificationReceivedMessageSchema = z.object({
  type: z.literal('pushNotificationReceived'),
  content: z.any().optional()
}).extend(NativeMessageSchema.shape)

export type PushNotificationReceivedMessage = z.infer<typeof PushNotificationReceivedMessageSchema>